import baseUrl from '@/utils/baseUrl'
const config = {
    debug: process.env.NODE_ENV !== 'production', // process.env.NODE_ENV !== 'production'
    serviceHost: baseUrl,
    apiToken: 'a2b01bd7cbb0e304608f8bcc87dcbe1a_user',
    apiParam: {
      terminalType: 'h5',
      roleType: 'user',
      qType: 'api',
      version: '6.8',
      // latitude,
      // longitude,
      // city_name,
    },
    appid: 'wx5faaa9087fde2697',
    locationurl: 'http://cdapih5.51chg.cn/#/',
    prourl: 'http://mh5.chedaiol.com',
    _sys_v: '',
    _model: '',
    _imei: '',
  }
  
  export default config